module.exports = __webpack_public_path__ + "static/media/27.619ff50c.jpg";